import { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, LinearProgress } from '@material-ui/core';
import { HistoryProvider, HistoryContext } from './HistoryContext';
import { NavContext } from '../../contexts';
import { RequestHeader, RequestHistory } from './components';
import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../helpers/Common';

const useStyles = makeStyles({
    root: {
    }
});

const PageContent = (props) => {
    const classes = useStyles();
    const { setBreadcrumbRoot } = useContext(NavContext);

    const {
        state,
        isLoadingHistory,
        loadHistory,
        loadRequestDbType
    } = useContext(HistoryContext);

    const { requestId } = useParams();

    useEffect(() => {
        setBreadcrumbRoot("Request History");

        if (requestId)
            loadRequestDbType(requestId);
    }, []);

    useEffect(() => {
        if (
            state.requestDbType === DbType.ECC ||
            state.requestDbType === DbType.S4
        )
            loadHistory(requestId, state.requestDbType);
    }, [state.requestDbType]);

    return (
        <>
            {
                isLoadingHistory &&
                <LinearProgress color="primary" />
            }

            {
                state.history &&
                !isLoadingHistory &&
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <RequestHeader />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <RequestHistory />
                    </Grid>
                </Grid>                                             
            } 
        </>       
    );
}

export const HistoryPage = (props): JSX.Element =>
    <HistoryProvider>
        <PageContent />
    </HistoryProvider>;